// src/utils/zipExtractor.ts

import { unzip, strFromU8 } from 'fflate';

export interface ExtractedFile {
  name: string;
  path: string;
  content: ArrayBuffer;
  size: number;
}

/**
 * Extract files from a ZIP archive using fflate
 */
export async function extractZipFile(zipBuffer: ArrayBuffer): Promise<ExtractedFile[]> {
  return new Promise((resolve, reject) => {
    const files: ExtractedFile[] = [];
    
    unzip(new Uint8Array(zipBuffer), (err, data) => {
      if (err) {
        reject(new Error(`Failed to extract ZIP: ${err.message}`));
        return;
      }
      
      // Process each file in the ZIP
      for (const [path, content] of Object.entries(data)) {
        // Skip directories
        if (path.endsWith('/')) continue;
        
        // Skip macOS metadata files
        if (path.startsWith('__MACOSX/') || path.includes('/.DS_Store')) continue;
        
        // Get file name from path
        const name = path.split('/').pop() || path;
        
        files.push({
          name,
          path,
          content: content.buffer.slice(content.byteOffset, content.byteOffset + content.byteLength) as ArrayBuffer,
          size: content.length
        });
      }
      
      resolve(files);
    });
  });
}

/**
 * Check if a file is a ZIP archive
 */
export function isZipFile(filename: string): boolean {
  const lowerName = filename.toLowerCase();
  return lowerName.endsWith('.zip') || lowerName.endsWith('.7z');
}
